export * from "./osm.interfaces";
//# sourceMappingURL=index.js.map